import script from "./CollapsibleComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CollapsibleComponent.vue?vue&type=script&setup=true&lang=js"

import "./CollapsibleComponent.vue?vue&type=style&index=0&id=592e7cc0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-592e7cc0"]])

export default __exports__